/**
 * Notification utilities for Vue components
 * Provides consistent toast notifications across the application
 */

/**
 * Show success message using toastr or fallback to alert
 * @param {string} message - The success message to display
 */
export function showSuccessMessage(message) {
    const toastBody = document.getElementById("successToastBody");
    if (toastBody) {
        toastBody.textContent = message;
    }

    const solidSuccessToast = document.getElementById("solid-successToast");
    const toast = new bootstrap.Toast(solidSuccessToast);
    toast.show();
}

/**
 * Show error message using toastr or fallback to alert
 * @param {string} message - The error message to display
 */
export function showErrorMessage(message) {
    const toastBody = document.getElementById("errorToastBody");
    if (toastBody) {
        toastBody.textContent = message;
    }
    const solidDangerToast = document.getElementById("solid-dangerToast");
    const toast = new bootstrap.Toast(solidDangerToast);
    toast.show();
}

/**
 * Show info message using toastr or fallback to alert
 * @param {string} message - The info message to display
 */
export function showInfoMessage(message) {
    if (window.toastr) {
        window.toastr.info(message);
    } else {
        alert(message);
    }
}

/**
 * Show warning message using toastr or fallback to alert
 * @param {string} message - The warning message to display
 */
export function showWarningMessage(message) {
    if (window.toastr) {
        window.toastr.warning(message);
    } else {
        alert(message);
    }
}

/**
 * Vue mixin for notification methods
 * Can be used in Vue components to add notification methods
 */
export const notificationMixin = {
    methods: {
        showSuccessMessage,
        showErrorMessage,
        showInfoMessage,
        showWarningMessage,
    },
};
